export default "__VITE_ASSET__YKMmJ1r9__"